


















import { Vue } from "vue-property-decorator";
export default Vue.extend({
  props:{
    color :{
      type : String,
      default : "#9ACD32"
    }
  }
});
